import React from "react";
import { object, number, string } from "prop-types";

import LeftImageRightNews from "../../../molecules/LeftImageRightNews";
import DfpContainer from "../../../ads/dfp-container";
import { DfpComponent } from "../../../ads/dfp-component";
import CollectionTitleWithArrow from "../../../atoms/CollectionTitleWithArrow";

import { getSlotId } from "../../../utils/utils";
import { useDevice } from "../../../utils/react-utils";

import "./organism3.m.css";

const Organism3 = ({ collection, adSlot, numOfStories }) => {
  if (!(collection && collection.items && collection.items.length)) return null;

  const { desktop } = useDevice();

  const { items = [] } = collection;

  const stories = items?.filter(({ type }) => type === "story").slice(0, numOfStories);

  return (
    <>
      {!desktop && <CollectionTitleWithArrow collection={collection} />}
      <div styleName="wrapper">
        <div styleName="story-wrapper">
          {stories.map(({ story }, index) => (
            <LeftImageRightNews
              story={story}
              key={index}
              aspectRatio={[1, 1]}
              imageType="image1x1"
              widths={[100, 150, 100]}
            />
          ))}
        </div>
        {adSlot && (
          <div styleName="ad-wrapper">
            <DfpContainer>
              <div className="adsBox">
                <DfpComponent
                  type={adSlot}
                  collectionSlug={collection.slug}
                  slotId={getSlotId(adSlot, collection.slug, "six-stories-1-widget-with-poll")}
                  layoutName="SixStories1WidgetWithPoll"
                />
              </div>
            </DfpContainer>
          </div>
        )}
      </div>
    </>
  );
};

Organism3.propTypes = {
  collection: object.isRequired,
  adSlot: string,
  numOfStories: number,
};

export default Organism3;
